﻿/**
 * portal-favorites.manager
 * @namespace portal
 */

(function () {
	'use strict';

	/** add model */
	angular.module('nha.portal').service('portal-favorites.manager', portalFavoritesManager);

	/** setup injection */
	portalFavoritesManager.$inject = ['$q', 'pub-sub.factory', 'staff-favorite.repository'];

	/** implement the model */
	function portalFavoritesManager($q, pubSubFactory, staffFavoriteRepository) {
		/** create pub sub manager */
		var pubSubManager = new pubSubFactory(['portal-favorites'], 'memory', 'portal');

		/** public methods */
		pubSubManager.getFavorites = getFavorites;
		pubSubManager.toggleFavorite = toggleFavorite;
		pubSubManager.reorderFavorites = reorderFavorites;

		/** return the pub sub */
		return pubSubManager;

		/** public method implementations */

		/** retrieve the users favorites */
		function getFavorites() {
			/** create a promise */
			var deferred = $q.defer();

			/** check for favorites data */
			var favorites = pubSubManager.getData('portal-favorites');
			if (favorites !== null) {
				/** resolve with favorites */
				deferred.resolve(favorites);
			} else {
				/** request favorites */
				staffFavoriteRepository.getForUser().then(function(favorites) {
					/** set favorites */
					pubSubManager.setData('portal-favorites', favorites);

					/** resolve with favorites */
					deferred.resolve(favorites);
				});
			}

			/** return the promise */
			return deferred.promise;
		}

		/** favorite a link */
		function toggleFavorite(link) {
			/** create a promise */
			var deferred = $q.defer();

			/** check the favorite flag */
			if (link.isFavorite) {
				/** delete the favorite */
				staffFavoriteRepository.deleteForUser(link.portalLinkID).then(function() {
					/** toggle the isFavorite value */
					link.isFavorite = false;
					removeFavorite(link, deferred);
				});
			} else {
				/** save the favorite */
				staffFavoriteRepository.post({ 'portalLinkID': link.portalLinkID }).then(function(favorite) {
					/** toggle the isFavorite value */
					link.favoriteOrderNumber = favorite.orderNumber;
					link.isFavorite = true;
					addFavorite(link, deferred);
				});
			}

			/** return the promise */
			return deferred.promise;
		}

		/** reorder the favorites */
		function reorderFavorites(favorites) {
			/** create a promise */
			var deferred = $q.defer();

			/** delete the favorite */
			staffFavoriteRepository.reorder(favorites).then(function() {
				/** set the new favorites */
				pubSubManager.setData('portal-favorites', favorites);

				/** resolve with favorites */
				deferred.resolve(favorites);
			});

			/** return the promise */
			return deferred.promise;
		}

		/** private methods */

		/** add a favorite */
		function addFavorite(link, deferred) {
			/** get the favorites and add one */
			getFavorites().then(function(favorites) {
				/** add a favorite */
				favorites.push(link);

				/** set the new favorites */
				pubSubManager.setData('portal-favorites', favorites);

				/** resolve with favorites */
				deferred.resolve(favorites);
			});
		}

		/** remove a favorite */
		function removeFavorite(link, deferred) {
			/** get the favorites and add one */
			getFavorites().then(function(favorites) {
				/** remove the favorite */
				_.remove(favorites, function(fav) {
					return fav.portalLinkID === link.portalLinkID;
				});

				/** set the new favorites */
				pubSubManager.setData('portal-favorites', favorites);

				/** resolve with favorites */
				deferred.resolve(favorites);
			});
		}
	}
})();